module.exports = __webpack_public_path__ + "img/e_charger_disabled.917115b3.svg";